function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, createContext } from 'react';
import { DndProvider as ReactDndProvider } from 'react-dnd';
import { MultiBackend } from 'dnd-multi-backend';
export const PreviewPortalContext = /*#__PURE__*/createContext(null);
export const DndProvider = _ref => {
  let {
    portal,
    ...props
  } = _ref;
  const [previewPortal, setPreviewPortal] = useState(null);
  return /*#__PURE__*/React.createElement(PreviewPortalContext.Provider, {
    value: portal !== null && portal !== void 0 ? portal : previewPortal
  }, /*#__PURE__*/React.createElement(ReactDndProvider, _extends({
    backend: MultiBackend
  }, props)), portal ? null : /*#__PURE__*/React.createElement("div", {
    ref: setPreviewPortal
  }));
};